import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useCategoryStore } from "../store/categoryStore";
import { getFeaturedCategories } from "../services/api";

export default function Layout({ children }) {
  const setCategories = useCategoryStore((s) => s.setCategories);

  useEffect(() => {
    getFeaturedCategories().then((data) => {
      const list = Array.isArray(data) ? data : data?.items || [];
      setCategories(list);
    });
  }, []);

  return (
    <div className="bg-off_white text-gray-100 min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
